import { Dispatch, SetStateAction } from "react";

export type StartingDateFilterTypes = "soon" | "this-week" | "next-week";

export type RequestLengthFilterTypes = "single-day" | "multi-day" | "long-term";

export type RequestTypeFilterTypes = "worked-before" | "new-today";

export type RadiusFilterType = 5 | 10 | 20 | 30 | 50 | 60 | 80;

export type GeocodeData = {
  latitude: number;
  longitude: number;
  latQ: number;
  lonQ: number;
  state: string;
  zipcode: string;
};

export type LocationFilterValueTypes = {
  radius: RadiusFilterType;
  zipcode: string;
  recentZipcodes: string[];
  userZipcode: string; // The user's registered address zipcode
  userState: string; // The user's registered state for validation
  geocode: GeocodeData | null; // Pre-computed geocode data for the current zipcode
};

export const initialLocationFilterValues: LocationFilterValueTypes = {
  radius: 20,
  zipcode: "",
  recentZipcodes: [],
  userZipcode: "",
  userState: "",
  geocode: null,
};

export type LocalStorageFilterValueTypes = {
  startingDate: StartingDateFilterTypes[];
  requestLength: RequestLengthFilterTypes[];
  requestType: RequestTypeFilterTypes[];
};

export type ThreadedData = {
  ls: LocalStorageFilterValueTypes;
  setLs: Dispatch<SetStateAction<LocalStorageFilterValueTypes>>;
};

export const initialLocalStorageFilterValues: LocalStorageFilterValueTypes = {
  startingDate: [],
  requestLength: [],
  requestType: [],
};

export type UnifiedFilterType =
  | StartingDateFilterTypes
  | RequestLengthFilterTypes
  | RequestTypeFilterTypes;
